import { Box, Flex } from 'rebass'
import styled from 'styled-components'

import { FieldError } from '../shared/styledComponents'
import { ClaimDatePicker } from './TdsDatePicker'

const StyledDatePicker = styled.div`
  margin-left: 32%;
  @media (max-width: 668px) {
    margin-left: 0%;
  }
`
const disabledDatesFunction = (date: Date) =>{
  return date.getTime() > Date.now()
}

const StyledError = styled(FieldError)`
  margin-top:-20px;
`

type DatePickerProps = {
  disabled: boolean
  input: {
    value: string
    onChange(value: Date | string): void
  }
  label: string
  meta: {
    touched: boolean
    error: string
  }
  disabledDates?: string
}

const DateOfLossPicker = ({
  disabled,
  input,
  label,
  meta:
    {
      touched,
      error
    },
  disabledDates
}: DatePickerProps) => (
  <Flex flexWrap="wrap">
    <Box width={[1, 1 / 3]}>
      <label htmlFor="dateOfLoss">{label}</label>
    </Box>
    <Box width={[1, 1 / 2]}>
      <StyledDatePicker>
        <ClaimDatePicker
          id='dateOfLoss'
          value={input.value ? input.value : undefined}
          onChange={(value: string) => input.onChange(value)}
          trigger='calendar'
          disabledDatesFunction={disabledDatesFunction}
          disabled={disabled}
          disabledDates={disabledDates}
        />
      </StyledDatePicker>
      <StyledError>{touched && error && <span>{error}</span>}</StyledError>
    </Box>
  </Flex>
)

export {
  DateOfLossPicker
}
